import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../json_query';
import { SubscriptionType, TSubscriptionType } from './serp_subscribe';

export function trackSuccessfulSubscribe(
  email: string,
  jsonQuery: IJsonQuery,
  subscriptionType: TSubscriptionType,
  aggregatedOffers: number,
  offersPerPage: number,
) {
  const isShortView = aggregatedOffers < offersPerPage;

  let label = '';

  if (subscriptionType === SubscriptionType.NothingFound) {
    label = 'From_Empty';
  } else if (subscriptionType === (SubscriptionType.Bottom as TSubscriptionType)) {
    label = `From_cat_${isShortView ? 'short' : 'long'}`;
  }

  ca('event', {
    email,
    name: 'oldevent',
    action: 'Send',
    category: 'subscription',
    label,
    searchConditions: jsonQuery,
  });
}
